import { UNIFIED } from 'src/app/analytics/analyticsEvents';

import { BaseModal } from '../Base/BaseModal';

interface RequestRefillModalProps {
  requestRefillModalStatus: { isShown: boolean; success: boolean };
  hideRequestRefillModal(): void;
}

export const Renderer = ({ requestRefillModalStatus, hideRequestRefillModal }: RequestRefillModalProps) => {
  if (!requestRefillModalStatus?.isShown) {
    return null;
  }

  return (
    <BaseModal
      showModal={requestRefillModalStatus.isShown}
      handleModalClosed={hideRequestRefillModal}
      closedEvent={UNIFIED.requestRefillModalClosed}
    >
      {requestRefillModalStatus.success ? (
        <div>Successfully requested refills.</div>
      ) : (
        <div>Issue requesting refills. Please try again later.</div>
      )}
    </BaseModal>
  );
};
